import * as constants from './actions';

import { getInitiatedTime } from '../../utils/actionTiming';

const initialState = {
    actionInitiated: false
};

export default function quiz(state = initialState, { type, payload }) {
    switch (type) {
        case constants.QUIZ_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                actionInitiated: true
            };
        case constants.QUIZ_SUCCESS:
            return {
                ...state,
                /* Deprecated, use answerHistory instead */
                quizAnswers: payload.results.map(r => ({
                    ...r,
                    answerId: parseInt(r.answerId, 10)
                })),
                results: payload.answers,
                /* Deprecated, use answerHistory instead */
                lastAnsweredQuiz: {
                    answerId: payload.answerId,
                    actionIdentifier: payload.actionIdentifier
                },
                answerHistory: (state.answerHistory || []).concat([
                    {
                        actionIdentifier: payload.actionIdentifier,
                        answerId: payload.answerId,
                        results: payload.answers
                    }
                ]),
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier],
                actionInitiated: false
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                successInfo: {
                    feedbackText: payload.feedbackText
                }
            };
        default:
            return state;
    }
}
